var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_6952_3226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FF2147"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 19.2C15.4206 19.2 14.8637 18.9757 14.4459 18.5743C14.0281 18.1728 13.7819 17.6252 13.7588 17.0462L13.4632 9.58125C13.4513 9.27951 13.5005 8.97847 13.6078 8.69619C13.7151 8.41392 13.8782 8.15621 14.0875 7.93852C14.2968 7.72083 14.5479 7.54763 14.8257 7.42932C15.1036 7.31101 15.4024 7.25002 15.7044 7.25H16.2957C16.5976 7.25002 16.8965 7.31101 17.1743 7.42932C17.4522 7.54763 17.7033 7.72083 17.9125 7.93852C18.1218 8.15621 18.285 8.41392 18.3923 8.69619C18.4996 8.97847 18.5488 9.27951 18.5369 9.58125L18.2413 17.0462C18.2182 17.6252 17.972 18.1728 17.5542 18.5743C17.1364 18.9757 16.5795 19.2 16 19.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.2394 22.5109C18.2394 21.2741 17.2368 20.2715 16 20.2715C14.7632 20.2715 13.7606 21.2741 13.7606 22.5109C13.7606 23.7476 14.7632 24.7502 16 24.7502C17.2368 24.7502 18.2394 23.7476 18.2394 22.5109Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6952_3226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/payment_failed.d709962fb16e44bcdde5b9e05e34e4c0.svg";
export { ForwardRef as ReactComponent };